<template>
  <div>
    <div class="content">
      <div class="cont-list">
        <span class="list">{{
          this.parentRoute.menuName + "-" + this.route.menuName
        }}</span>
        <span class="masge">当前共有{{ total }}个角色</span>
      </div>
      <div class="header">
        <div class="left">
          <el-button v-if="tableAcl.indexOf('Add') != -1" class="btn primary" type="primary" size="small" v-preventReClick @click="handleAdd">新增</el-button>
          <el-button v-if="tableAcl.indexOf('Remove') != -1" class="btn" size="small" :disabled="multiple" v-preventReClick @click="handleDelete">
            {{ cancelButtonText }}
          </el-button>
        </div>
        <div class="right">
          <div class="search">
            <el-input type="text" v-model="query.keyWord" @keyup.enter.native="queryChange">
              <i slot="suffix" class="el-icon-search" @click="queryChange"></i>
            </el-input>
            <!-- <i class="el-icon-search padding10" v-preventReClick @click="queryChange"></i> -->
          </div>
          <span v-preventReClick @click="reset">重置</span>
        </div>
      </div>

      <!-- <el-tabs v-model="query.appId" @tab-click="tabClick">
        <el-tab-pane v-for="item in AppCategory" :key="item.id" :label="item.name" :name="item.id"></el-tab-pane>
      </el-tabs> -->
      <el-tabs v-model="query.appId" @tab-click="tabClick" stretch>
        <el-tab-pane v-for="item in apps" :key="item.id" :name="item.id + ''">
          <template slot="label">
            <span style="margin: 0 10px"> {{ item.name }} </span>
          </template>
        </el-tab-pane>
      </el-tabs>

      <el-table ref="multipleTable" border row-key="id"  v-loading="loading" :data="tableData" :max-height="tableHeight" style="width: 100%;margin-top:10px" @selection-change="handleSelectionChange" stripe :header-cell-style="{ background: '#DDEBFF' }">
        <template slot="empty">
          <div class="empty-div" :style="{ height: tableHeight + 'px' }">
            <img src="../../../../assets/noData.png" width="240" height="240" />
            <span class="empty-span">抱歉！当前搜索状态下暂无相关数据，请核对后再查询！</span>
            <div class="empty-rest" @click="reset">恢复默认</div>
          </div>
        </template>
        <el-table-column align="center" :reserve-selection="true" type="selection" fixed width="55">
        </el-table-column>
        <el-table-column prop="name" label="名称" min-width="150">
        </el-table-column>
        <el-table-column prop="isAdmin" label="是否管理员" min-width="150">
          <template slot-scope="scope">
            {{ getBoolName(scope.row.isAdmin) }}
          </template>
        </el-table-column>
        <el-table-column prop="desc" label="角色描述" min-width="150" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.desc??'-' }}
          </template>
        </el-table-column>

        <el-table-column prop="createdTime" label="创建时间" min-width="170">
          <template slot-scope="scope">
            {{ parseTime(new Date(scope.row.createdTime), "{y}-{m}-{d} {h}:{i}:{s}") }}
          </template>
        </el-table-column>
        <el-table-column prop="updateTime" label="更新时间" min-width="170">
          <template slot-scope="scope">
            {{ parseTime(new Date(scope.row.updateTime)) }}
          </template>
        </el-table-column>
        <el-table-column prop="stateName" label="状态" width="80">
          <template slot-scope="scope">
            <span :class="{
                enable: scope.row.state == 1,
                forbidden: scope.row.state == 0,
              }">{{ scope.row.stateName }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="operation" label="操作" width="340">
          <template slot-scope="scope">
            <el-button type="text" v-preventReClick @click="handleInfo(scope.row)" class="color-blue">查看</el-button>
            <el-button v-if="tableAcl.indexOf('Edit') != -1" type="text" v-preventReClick @click="handleUpdate(scope.row)" class="margin-left20 color-blue">编辑</el-button>
            <el-button type="text" v-preventReClick @click="showAddUser(scope.row)" class="margin-left20 color-blue">关联成员</el-button>
            <el-button type="text" v-preventReClick @click="showAclSetting(scope.row)" class="margin-left20 color-blue">角色配置</el-button>
            <el-button v-if="tableAcl.indexOf('Remove') != -1" type="text" v-preventReClick @click="handleDelete(scope.row)" class="margin-left20 color-blue">{{ scope.row.state === 0 ? "启用" : "禁用" }}</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-dialog :title="title + '角色'" :visible.sync="open" :center="true" width="500px" :before-close="cancel" :close-on-click-modal="false">
        <el-form label-position="top" label-width="80px" ref="form" :model="form" :rules="rules">
          <el-form-item label="名称" prop="name">
            <el-input v-model="form.name" :disabled="!editMode" placeholder="请输入名称"></el-input>
          </el-form-item>
          <el-form-item label="是否管理员">
            <el-switch v-model="form.isAdmin" :disabled="!editMode" active-color="#286AB4" inactive-color="#D4D4D4" :active-value="1" :inactive-value="0">
            </el-switch>
            <span v-if="form.isAdmin">是</span>
            <span v-else>否</span>
          </el-form-item>
          <el-form-item label="备注">
            <el-input v-model="form.desc" :disabled="!editMode" placeholder="请输入备注"></el-input>
          </el-form-item>
          <el-form-item label="启用状态">
            <el-switch v-model="form.state" :disabled="!editMode" active-color="#286AB4" inactive-color="#D4D4D4" :active-value="1" :inactive-value="0">
            </el-switch>
            <span v-if="form.state">已启用</span>
            <span v-else>已禁用</span>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button class="btn" size="small" v-preventReClick @click="cancel">取 消</el-button>
          <el-button class="btn primary" type="primary" v-if="editMode" size="small" v-preventReClick @click="submit">确 定</el-button>
        </div>
      </el-dialog>

      <el-dialog title="新增成员" :visible.sync="showAddUserDialog" :center="true" width="1000px" :close-on-click-modal="false">
        <el-button class="btn primary" type="primary" size="small" v-preventReClick @click="handleAddRoleUser">新增</el-button>
        <el-button class="btn" size="small" :disabled="userMultiple" v-preventReClick @click="deleteRoleUser">
          移除
        </el-button>
        <el-table ref="roleUserTable" border :data="roleUsers" tooltip-effect="dark" style="margin:10px 0px" height="400px" @selection-change="roleUserTableSelectionChange" stripe :header-cell-style="{ background: '#DDEBFF' }">
          <el-table-column type="selection" fixed align="center" width="55">
          </el-table-column>
          <el-table-column prop="no" label="工号" width="100">
          </el-table-column>
          <el-table-column prop="name" label="名称" width="100">
          </el-table-column>
          <el-table-column prop="mobile" label="联系方式"></el-table-column>
          <el-table-column prop="deptName" label="主科室" min-width="120" show-overflow-tooltip></el-table-column>
          <el-table-column prop="deptNames" label="附属科室" min-width="120">
            <template slot-scope="scope">
              <template v-if="scope.row.deptInfos && scope.row.deptInfos.length > 0">
                <el-tooltip effect="light" placement="bottom" popper-class="tooltip-content">
                  <div slot="content" class="">
                    <div class="tooltip-text" v-for="item in scope.row.deptInfos" :key="item.id">
                      {{ item.name }}
                    </div>
                  </div>
                  <span class="td-overflow-hidden">{{
                    scope.row.deptNames
                  }}</span>
                </el-tooltip>
              </template>
              <template v-else>
                <span class="td-overflow-hidden">{{
                  scope.row.deptNames
                }}</span>
              </template>
            </template>
          </el-table-column>
          <el-table-column prop="warehouseNames" label="关联库房" min-width="120">
            <template slot-scope="scope">
              <template v-if="
                  scope.row.warehouseInfos &&
                    scope.row.warehouseInfos.length > 0
                ">
                <el-tooltip effect="light" placement="bottom" popper-class="tooltip-content">
                  <div slot="content" class="">
                    <div class="tooltip-text" v-for="item in scope.row.warehouseInfos" :key="item.id">
                      {{ item.name }}
                    </div>
                  </div>
                  <span class="td-overflow-hidden">{{
                    scope.row.warehouseNames
                  }}</span>
                </el-tooltip>
              </template>
              <template v-else>
                <span class="td-overflow-hidden">{{
                  scope.row.warehouseNames
                }}</span>
              </template>
            </template>
          </el-table-column>
        </el-table>
      </el-dialog>

      <el-dialog title="角色配置" :visible.sync="showAclSettingDialog" :center="true" width="1100px" :before-close="cancelAclSetting" :close-on-click-modal="false">
        <el-button class="btn primary" type="primary" size="small" v-preventReClick @click="saveAclData">确 定</el-button>
        <el-button class="btn" size="small" v-preventReClick @click="cancelAclSetting">取 消</el-button>
        <el-button class="btn" size="small" v-preventReClick @click="copyAclSetting">复 制</el-button>
        <el-table ref="aclTable" border :data="aclDatas" tooltip-effect="dark" @current-change="expandChange" :expand-row-keys="defaultExpandKeys" style="margin:10px 0px" height="500px" row-key="id" :tree-props="{ children: 'children' }" stripe :header-cell-style="{ background: '#DDEBFF' }">
          <el-table-column min-width="20%" label="菜单权限">
            <template slot-scope="scope">
              <el-checkbox v-model="scope.row.moduleAuth" @change="moduleChange(scope.row)">{{ scope.row.moduleName }}</el-checkbox>
            </template>
          </el-table-column>
          <el-table-column min-width="45%" label="操作权限">
            <template slot-scope="scope" v-if="scope.row.moduleType == 1 || scope.row.moduleType == 3">
              <div style="display:flex">
                <el-checkbox :disabled="!scope.row.moduleAuth" v-model="scope.row.allFormAcl" @change="formAclCheckAllChange(scope.row)">全选</el-checkbox>
                <el-checkbox-group :disabled="!scope.row.moduleAuth" v-model="scope.row.formAclArray" @change="formAclCheckChange(scope.row)">
                  <el-checkbox v-for="item in scope.row.formAclOptions" :key="item.code" :label="item.code">{{ item.name }}</el-checkbox>
                </el-checkbox-group>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="数据权限" min-width="20%" align="center">
            <template slot-scope="scope" v-if="scope.row.moduleType != 0 ">
              <el-radio-group :disabled="!scope.row.moduleAuth" v-model="scope.row.dataRange">
                <el-radio :label="0">全部</el-radio>
                <el-radio :label="1">配置科室</el-radio>
                <el-radio :label="2">自己</el-radio>
              </el-radio-group>
            </template>
          </el-table-column>
        </el-table>
      </el-dialog>

      <select-user :show="showSelectUser" :oldData="roleUsers" @getData="getSelectUserData" @close="closeSelectUser"></select-user>
    </div>
    <div class="pagination">
      <el-pagination background layout="sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 50, 100, 200, 500, 1000]" :page-size="query.pageSize" @size-change="handleSizeChange" :current-page="query.pageIndex" :total="total" @current-change="changePage">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import {
  GetRoles,
  SaveRole,
  // RemoveRoles,
  RoleAddUser,
  RoleRemoveUser,
  UpdateRoleStatesById,
  SaveAcl,
  GetAclsByRoleId,
  GetUsersByRoleId,
  CopyAclsByRoleId,
} from "@/api";
import GetDataMixin from "@/mixin/getData-mixin.js";
import SelectUser from "@/components/select-user";
// import { AppCategory } from "@/enum";

export default {
  mixins: [GetDataMixin],
  components: {
    SelectUser,
  },
  data () {
    return {
      // 查询条件
      query: {
        keyWord: "",
        pageSize: 10,
        pageIndex: 1,
        appId: "1",
      },
      // 列表数据
      tableData: [],
      // 列表总数
      total: 0,
      // 弹出框标题
      title: "",
      // 弹出编辑框
      open: false,
      editMode: false,
      // 新增、编辑的数据
      form: {},
      // 多选框数据
      ids: [],
      multipleSelection: [],
      // 列表多选
      multiple: true,
      rules: {
        // no: [{ required: true, message: "请输入编码", trigger: "blur" }],
        name: [{ required: true, message: "请输入名称", trigger: "blur" }],
      },
      // AppCategory: AppCategory,
      roleId: 0,
      showAddUserDialog: false,
      showAclSettingDialog: false,
      roleUsers: [],
      aclDatas: [],
      userMultipleSelection: [],
      userMultiple: true,
      roleUserIds: [],
      showSelectUser: false,
      cancelButtonText: "禁用",
      defaultExpandKeys: [],
      finishOrderModules: ["PurchaseOrder", "StockUpPlan", "SurgicalApply"],
      setRfidModules: ['ApplyOutStock', 'StockUpCheck', 'PeriodStock']
    };
  },
  computed: {
    apps () {
      return this.$store.state.user.apps;
    },
  },
  methods: {
    handleSelectionChange (selection) {
      this.multipleSelection = selection;
      this.ids = selection.map((item) => item.id);
      this.multiple = !selection.length;

      this.cancelButtonText =
        selection && selection.length > 0 && selection[0].state == 0
          ? "启用"
          : "禁用";
    },
    // 获取列表
    getData () {
      GetRoles(this.query).then((res) => {
        this.tableData = res.returnData.data;
        this.total = res.returnData.totalCount;
      });
    },
    // 新建
    handleAdd () {
      this.open = true;
      this.title = "新建";
      this.resetForm();
      this.editMode = true;
    },
    handleInfo (row) {
      this.resetForm();
      this.form = JSON.parse(JSON.stringify(row));
      this.open = true;
      this.editMode = false;
    },
    // 编辑
    handleUpdate (row) {
      this.resetForm();
      this.form = JSON.parse(JSON.stringify(row));
      // this.form.state = Boolean(this.form.state);
      this.open = true;
      this.title = "编辑";
      this.editMode = true;
    },
    // 保存
    submit () {
      this.$refs["form"].validate((valid) => {
        if (!valid) {
          return false;
        }
        SaveRole(this.form)
          .then((res) => {
            this.open = false;
            this.$my_message(`执行成功`, "success");
            this.getData();
          })
          .finally((res) => {
            // this.form.state = Boolean(this.form.state);
          });
      });
    },
    resetForm () {
      this.form = {
        name: "",
        isAdmin: 0,
        desc: "",
        appId: this.query.appId,
        state: 1,
        orgCode :sessionStorage.getItem('orgId'),
      };
    },
    // 取消编辑部门
    cancel () {
      if (this.editMode) {
        this.$my_confirm("确认要中断当前操作吗？", "提示", {
          type: "warning",
        })
          .then(() => {
            this.open = false;
          })
          .catch(() => { });
      } else {
        this.open = false;
      }
    },
    // 改变当前页
    changePage (val) {
      this.$set(this.query, "pageIndex", val);
      this.getData();
    },
    handleSizeChange (val) {
      this.$set(this.query, "pageSize", val);
      this.getData();
    },
    tabClick () {
      this.ids = []
      this.multipleSelection = []
      this.multiple = true;

      if (this.$refs.multipleTable) {
        this.$refs.multipleTable.clearSelection()
      }
      // this.$set(this.query, 'appId', id);
      this.getData();
    },

    // 删除部门
    handleDelete (row) {
      let ids = [];
      let state = 0;
      if (row && row.id) {
        ids = [row.id];
        state = row.state == 1 ? 0 : 1;
      } else {
        state = this.multipleSelection[0].state == 1 ? 0 : 1;
        let stateDatas = this.multipleSelection.filter((e) => e.state == state);
        if (stateDatas.length >= 1) {
          this.$my_message("请只选择一种状态的数据！", "warning");
          return;
        }
        ids = this.ids;
      }
      // const ids = row && row.id ? [row.id] : this.ids;

      this.$my_confirm("此操作将改变数据状态, 是否继续?", "提示", {
        type: "warning",
      })
        .then(() => {
          return UpdateRoleStatesById({ ids, state });
        })
        .then(() => {
          this.$my_message(`操作成功！`, "success");
          this.getData();
        })
        .catch(() => { });
    },
    // 重置
    reset () {
      this.query.keyWord = "";
      this.$set(this.query, "pageIndex", 1);
      this.$set(this.query, "pageSize", 10);
      this.ids = []
      this.multipleSelection = []
      this.multiple = true;

      if (this.$refs.multipleTable) {
        this.$refs.multipleTable.clearSelection()
      }
      this.getData();
    },
    queryChange () {
      this.$set(this.query, "pageIndex", 1);
      this.getData();
    },
    /** 绑定成员 */
    getRoleUsers () {
      GetUsersByRoleId({ roleId: this.roleId }).then((res) => {
        this.roleUsers = res.returnData.data;
      });
    },
    showAddUser (row) {
      this.loading = true
      this.roleId = row.id;
      GetUsersByRoleId({ roleId: this.roleId }).then((res) => {
        this.roleUsers = res.returnData.data;
        this.showAddUserDialog = true;
        this.loading = false
      });
      // this.showAddUserDialog = true;
      // this.getRoleUsers();
    },
    roleUserTableSelectionChange (selection) {
      this.userMultipleSelection = selection;
      this.roleUserIds = selection.map((item) => item.id);
      this.userMultiple = !selection.length;
    },
    deleteRoleUser () {
      // 删除
      RoleRemoveUser({ ids: this.roleUserIds, id: this.roleId }).then((res) => {
        this.getRoleUsers();
      });
    },
    handleAddRoleUser () {
      this.showSelectUser = true;
    },
    getSelectUserData (data) {
      // console.log(data, 'getSelectUserData')
      let ids = data ? data.map((e) => e.id) : [];
      // save role user
      RoleAddUser({ ids: ids, id: this.roleId }).then((res) => {
        this.getRoleUsers();
      });
    },
    closeSelectUser () {
      this.showSelectUser = false;
    },
    showAclSetting (row) {
      this.showAclSettingDialog = true;
      this.roleId = row.id;
      GetAclsByRoleId({ roleId: row.id, appId: this.query.appId }).then(
        (res) => {
          res.returnData.map((item) => {
            item.formAclOptions = [
              { code: "Add", name: "新增" },
              { code: "Edit", name: "编辑" },
              { code: "Import", name: "导入" },
              { code: "Export", name: "导出" },
              { code: "Remove", name: "删除" },
              { code: "Print", name: "打印" },
            ];

            item.allFormAcl = Boolean(item.allFormAcls);

            if (item.children) {
              item.children.map((child) => {
                child.formAclOptions = [
                  { code: "Add", name: "新增" },
                  { code: "Edit", name: "编辑" },
                  { code: "Import", name: "导入" },
                  { code: "Export", name: "导出" },
                  { code: "Remove", name: "删除" },
                  { code: "Print", name: "打印" },
                ];

                child.allFormAcl = Boolean(child.allFormAcls);
                if (child.moduleCode == 'User') {
                  child.formAclOptions.push({ code: "UpdatePassword", name: "修改密码" })
                }
                if (child.moduleCode == 'SupplierProduct') {
                  child.formAclOptions.push({ code: "ApproveCert", name: "审批证件" })
                  child.formAclOptions.push({ code: 'Cancel', name: '批量禁用' })
                }
                if (child.moduleCode == 'PurchaseApply') {
                  child.formAclOptions.push({ code: "ToPlan", name: "生成采购计划" })
                  child.formAclOptions.push({ code: "ApplyOutStock", name: "请领出库" })
                  child.formAclOptions.push({ code: "FinishPurchaseApply", name: "终止请领" })
                  child.formAclOptions.push({ code: "Copy", name: "复制" })
                  child.formAclOptions.push({ code: "PickingStock", name: "生成拣货单" })
                }
                if (child.moduleCode == "StockUpApply") {
                  child.formAclOptions.push({ code: "ToPlan", name: "生成备货计划" })
                }
                if (child.moduleCode == "PurchasePlan") {
                  child.formAclOptions.push({ code: "ToOrder", name: "汇总生成订单" })
                  child.formAclOptions.push({ code: "Copy", name: "复制" })
                }
                if(child.moduleCode == 'PurchasePlan'||child.moduleCode == 'PurchaseOrder'||child.moduleCode=='ProductPriceUpdate'||child.moduleCode=='SupplierProduct' ){
                  child.formAclOptions.push({ code: "BatchApproves", name: "批量审批" })
                }
                if (this.finishOrderModules.indexOf(child.moduleCode) != -1) {
                  child.formAclOptions.push({ code: "FinishOrder", name: "关闭订单" })
                }
                if (this.setRfidModules.indexOf(child.moduleCode) != -1) {
                  child.formAclOptions.push({ code: "SetRfid", name: "Rfid赋码" })
                }

                let priceMonitorModules = ["PushPurchaseOrder", "PushPurchaseInStock", "PushPurchaseOutStock", "PushPurchaseOutStockReagent", "PushPurchaseInStockReagent", "PushPurchaseOrderReagent", "PushPayOrderProduct", "PushPayOrderReagent"]
                if (priceMonitorModules.indexOf(child.moduleCode) != -1) {
                  child.formAclOptions.push({ code: "Push", name: "确认上传" })
                }

                let CompareModules = ["CompanyCompare", "GoodCompare", "CompanyCompareReagent", "GoodCompareReagent"]
                if (CompareModules.indexOf(child.moduleCode) != -1) {
                  child.formAclOptions.push({ code: "Compare", name: "对照" })
                  child.formAclOptions.push({ code: "CancelCompare", name: "取消对照" })
                }

                let cancelModules = ["PaymentApply"]
                if (cancelModules.indexOf(child.moduleCode) != -1) {
                  child.formAclOptions.push({ code: "Cancel", name: "作废" })
                }

                let copyModules = ["InvoiceRegister"]
                if (copyModules.indexOf(child.moduleCode) != -1) {
                  child.formAclOptions.push({ code: "Copy", name: "复制" })
                  child.formAclOptions.push({ code: "Cancel", name: "作废" })
                }
                if (child.moduleCode == "CollectOutStock") {
                  child.formAclOptions.push({ code: "CollectInStock", name: "退库" })
                }
                // 修改权限 （合同）
                if (child.moduleCode == "SpdContract") {
                  child.formAclOptions.push({ code: "Modify", name: "修改" })
                }

                if (child.moduleCode == "DeptInStock") {
                  child.formAclOptions.push({ code: "DeptOutStock", name: "退库" })
                  child.formAclOptions.push({ code: "CollOutStock", name: "出库" })
                }
                if (child.moduleCode == 'HisCharge') { //计费数据
                  child.formAclOptions.push({ code: "Refund", name: "退费" })
                }

                if (child.moduleCode == "PurchaseDistribution") {
                  child.formAclOptions.push({ code: "InStock", name: "入库" })
                  child.formAclOptions.push({ code: "BatchDistribution", name: "入库并分发" })
                }
                if (child.moduleCode == "AcceptInStock") {
                  child.formAclOptions.push({ code: "OutStock", name: "退货" })
                  child.formAclOptions.push({ code: "MergePrint", name: "合并打印" })
                  child.formAclOptions.push({ code: "WholeOutStock", name: "整出" })
                
                }
                if (child.moduleCode == "ApplyOutStock") {
                  child.formAclOptions.push({ code: "MergePrint", name: "合并打印" })
                }
                
                if (child.moduleCode == 'ProcurementCatalog') { //药品采购目录
                  child.formAclOptions.push({ code: "AuthEnable", name: "启用" })
                  child.formAclOptions.push({ code: 'AuthDisable', name: '禁用' })
                  child.formAclOptions.push({ code: 'MoreActions', name: '更多' })
                }
                if (child.moduleCode == 'DeptMedication') { //药品科室药品
                  
                }
                if (child.moduleCode == 'ProcPlan') { //药品采购计划
                  child.formAclOptions.push({ code: 'AuthRecall', name: '撤回' })
                  child.formAclOptions.push({ code: 'AuthAbort', name: '中止' })
                  child.formAclOptions.push({ code: 'GenerateOrder', name: '生成订单' })
                  child.formAclOptions.push({ code: 'Copy', name: '复制' })
                }
                if (child.moduleCode == 'ProcOrder') { //药品采购订单
                  child.formAclOptions.push({ code: 'AuthRecall', name: '撤回' })
                  child.formAclOptions.push({ code: "PurchasingPlanImport", name: "采购计划导入" })
                  child.formAclOptions.push({ code: 'AuthAbort', name: '中止' })
                  child.formAclOptions.push({ code: 'AuthPush', name: '推送' })
                  child.formAclOptions.push({ code: 'AuthAffirm', name: '确认' })
                }
                if (child.moduleCode == 'SupplierDeliveryNote') { //药品供应商配送单
                }
                if (child.moduleCode == 'AcetCertificate') { //药品采购验收单
                  child.formAclOptions.push({ code: 'AuthRecall', name: '撤回' })
                  child.formAclOptions.push({ code: 'DeliveryOrderImport', name: '配送单导入' })
                  child.formAclOptions.push({ code: 'AuthVoid', name: '作废' })
                }
                if (child.moduleCode == 'WarehouseEntry') { //药品入库单
                  child.formAclOptions.push({ code: "AuthInstorage", name: "入库" })
                  child.formAclOptions.push({ code: 'AuthVoid', name: '作废' })
                }
                if (child.moduleCode == 'ProcReturnGoods') { //药品采购退货
                  child.formAclOptions.push({ code: 'AuthRecall', name: '撤回' })
                  child.formAclOptions.push({ code: "ImportWarehouseEntry", name: "入库单导入" })
                  child.formAclOptions.push({ code: 'AuthPush', name: '推送' })
                }
                if (child.moduleCode == 'UseApply') { //药品领用申请单
                  child.formAclOptions.push({ code: 'AuthRecall', name: '撤回' })
                  child.formAclOptions.push({ code: "AuthAbort", name: "中止" })
                  child.formAclOptions.push({ code: 'GenerateOutletSlip', name: '生成出库单' })
                  child.formAclOptions.push({ code: 'Copy', name: '复制' })
                }
                if (child.moduleCode == 'UseOutStock') { //药品领用出库单
                  child.formAclOptions.push({ code: 'AuthRecall', name: '撤回' })
                  child.formAclOptions.push({ code: "RequisitionImport", name: "申领单导入" })
                  child.formAclOptions.push({ code: 'AuthVoid', name: '作废' })
                }
                if (child.moduleCode == 'UseInStock') { //药品领用入库单
                  child.formAclOptions.push({ code: "AuthInstorage", name: "入库" })
                  child.formAclOptions.push({ code: 'AuthRejection', name: '拒收' })
                }
                if (child.moduleCode == 'UseReturnApply') { //药品领用退回申请单
                  child.formAclOptions.push({ code: 'AuthRecall', name: '撤回' })
                  child.formAclOptions.push({ code: "ImportReceipt", name: "领用入库单导入" })
                  child.formAclOptions.push({ code: 'AuthVoid', name: '作废' })
                }
                if (child.moduleCode == 'UseReturnOutStock') { //药品领用退回出库
                  child.formAclOptions.push({ code: "AuthOutstorage", name: "出库" })
                  child.formAclOptions.push({ code: 'AuthVoid', name: '作废' })
                }
                if (child.moduleCode == 'UseReturnInStock') { //药品领用退回入库
                  child.formAclOptions.push({ code: "AuthInstorage", name: "入库" })
                  child.formAclOptions.push({ code: 'AuthRejection', name: '拒收' })
                }
                if (child.moduleCode == 'MedicationStock') { //药品库存明细表
                }
                if (child.moduleCode == 'StockLoss') { //药品库存报损单
                  child.formAclOptions.push({ code: 'AuthRecall', name: '撤回' })
                  child.formAclOptions.push({ code: 'AuthVoid', name: '作废' })
                }
                if (child.moduleCode == '	InitialInStock') { //药品期初入库单
                  child.formAclOptions.push({ code: 'AuthRecall', name: '撤回' })
                  child.formAclOptions.push({ code: 'AuthUpload', name: '上传' })
                  child.formAclOptions.push({ code: 'AuthVoid', name: '作废' })
                }
                if (child.moduleCode == 'ClosingBalance') { //药品期末结存
                }
                if (child.moduleCode == 'ClosingBalanceDetail') { //药品期末结存查询

                }
                if (child.moduleCode == 'InventoryCount') { //药品库存盘点
                  child.formAclOptions.push({ code: "AuthEntering", name: "实盘数录入" })
                  child.formAclOptions.push({ code: 'AuthRecall', name: '撤回' })
                  child.formAclOptions.push({ code: 'AuthClose', name: '关闭' })
                }
                if (child.moduleCode == '	InventoryInStock') { //药品盘点入库单
                }
                if (child.moduleCode == 'InventoryOutStock') { //药品盘点出库单
                }
                if (child.moduleCode == 'PriceAdjustment') { //药品调价单
                  child.formAclOptions.push({ code: 'AuthRecall', name: '撤回' })
                }
                if (child.moduleCode == 'ConsumeData') { //药品消耗数据
                  child.formAclOptions.push({ code: 'AuthRecall', name: '撤回' })
                  child.formAclOptions.push({ code: 'DepletionWithdrawal', name: '消耗撤回' })
                }
                if (child.moduleCode == 'ConsumeRevoke') { //药品消耗撤回
                  child.formAclOptions.push({ code: 'DepletionWithdrawalImport', name: '消耗撤回单导入' })
                  child.formAclOptions.push({ code: 'AuthRecall', name: '撤回' })
                }
                if (child.moduleCode == 'ConsumeChargingRefund') { //药品计费/退费
                  child.formAclOptions.push({ code: "AuthRecharge", name: "重新计费" })
                  child.formAclOptions.push({ code: 'AuthRefunds', name: '重新退费' })
                }
                if (child.moduleCode == 'InAndOutWarehouseFlow') { //药品出入库流水查询
                }
                if (child.moduleCode == 'YXPlatformProductData') { //药品常用目录对照
                  child.formAclOptions.push({ code: "UpdateMessage", name: "更新信息" })
                }
                if (child.moduleCode == 'DrugContract') { //药品合同管理
                  child.formAclOptions.push({ code: 'AuthRecall', name: '撤回' })
                  child.formAclOptions.push({ code: 'AuthVoid', name: '作废' })
                }
                if (child.moduleCode == 'DrugContract') { //药品发票列表
                  child.formAclOptions.push({ code: 'AuthRecall', name: '撤回' })
                  child.formAclOptions.push({ code: 'AuthVoid', name: '作废' })
                }
                return child;
              });
            }

            return item;
          });
          this.aclDatas = res.returnData;
        }
      );
    },
    formAclCheckAllChange (row) {
      row.formAclArray = row.allFormAcl
        ? row.formAclOptions.map((i) => i.code)
        : [];
      row.allFormAcls = Number(row.allFormAcl);
    },
    formAclCheckChange (row) {
      row.allFormAcl =
        row.formAclArray &&
        row.formAclArray.length == row.formAclOptions.length;
      row.allFormAcls = Number(row.allFormAcl);
    },
    moduleChange (row) {
      if (row.moduleAuth && (!row.dataRange || row.dataRange == 3)) {
        row.dataRange = 2;
      }

      // 如果子的有选中的  父的也要选中
      // 获取父
      let parentAcl = this.getParentAcl(row);
      this.changeParentAclState(parentAcl);
    },
    getParentAcl (row) {
      for (let i = 0; i < this.aclDatas.length; i++) {
        if (this.aclDatas[i].id == row.id) {
          return null;
        }
        if (this.aclDatas[i].children && this.aclDatas[i].children.length > 0) {
          for (let j = 0; j < this.aclDatas[i].children.length; j++) {
            if (this.aclDatas[i].children[j].id == row.id) {
              return this.aclDatas[i];
            }
          }
        }
      }

      return null;
    },
    changeParentAclState (row) {
      console.log(row);
      if (!row || !row.children) return;
      for (let i = 0; i < row.children.length; i++) {
        if (row.children[i].moduleAuth) {
          row.moduleAuth = true;
          return;
        }
      }

      row.moduleAuth = false;
    },
    expandChange (row, expand) {
      // this.defaultExpandKeys = []
      if (this.defaultExpandKeys.indexOf(row.id + "") < 0) {
        this.defaultExpandKeys.push(row.id + "");
      } else {
        this.defaultExpandKeys.remove(row.id + "");
      }
      // if (expand) {
      // this.$nextTick(() => {
      // this.defaultExpandKeys.push(row.id.toString())
      // })
      // }
    },
    saveAclData () {
      SaveAcl({ aclViewModels: this.aclDatas, roleId: this.roleId }).then(
        (res) => {
          if (res.successful) {
            this.$my_message(`保存成功`, "success");
            this.showAclSettingDialog = false;
          }
        }
      );
    },
    cancelAclSetting () {
      // this.showAclSettingDialog = false;
      this.$my_confirm("确认要中断当前操作吗？", "提示", {
        type: "warning",
      }).then(() => {
        this.showAclSettingDialog = false;
      });
    },
    copyAclSetting () {
      this.$my_confirm(
        "此操作会复制一条相同权限的角色数据，确定要继续吗？",
        "提示",
        {
          type: "warning",
        }
      )
        .then(() => {
          CopyAclsByRoleId({ roleId: this.roleId }).then((res) => {
            this.showAclSettingDialog = false;
            this.getData();
          });
        })
        .catch(() => { });
    },
  },

  mounted () {
    this.getData();
    this.getDepts("");
    this.getUsers("");
  },
};
</script>

<style lang="scss" scoped>
.el-radio,
.el-checkbox {
  margin-right: 10px !important;
}
.el-tabs {
  width: 700px;
  margin-bottom: 10px;
}
</style>
